import { ErrorReporter } from '@mode/shared/contract-common';
import '../../modules/mode-components';

import * as angular from 'angular';

function isMailToLink(href) {
  if (!href || typeof href !== 'string') {
    return false;
  }
  return href.indexOf('mailto:') === 0;
}

function IntercomShow($log: angular.ILogService, $window: Window, errorReporter: ErrorReporter) {
  function logFailure(intercomStatus: string) {
    const error = new Error(`Intercom widget failed on ${intercomStatus}`);
    $log.log(error.message);
    errorReporter.notify({ error });
  }

  return {
    restrict: 'A',
    link: function ($scope, $elem: JQuery, attrs) {
      if (!$scope.intercomEmail && !attrs.href) {
        $log.warn('Intercom fallback not provided');
      }

      $elem.on('click', function (ev) {
        // fallback to email or help link if Intercom isn't loaded
        if (typeof Intercom === 'undefined' || !Intercom.booted) {
          const intercomStatus = typeof Intercom === 'undefined' ? 'undefined' : 'uninitialized';
          logFailure(intercomStatus);

          if (!$scope.intercomEmail && attrs.href && !isMailToLink(attrs.href)) {
            $window.open(attrs.href, '_blank');
            ev.preventDefault();
            return;
          }
          // force page to given email unless mailto link is on element
          if (!isMailToLink(attrs.href)) {
            ev.preventDefault();
            // If fallback email wasn't provided, default to help
            $window.location.assign(
              `mailto:${$scope.intercomEmail || 'help@modeanalytics.com'}?subject=${$scope.intercomShow}`
            );
          }
        } else {
          ev.preventDefault();

          // if $scope.intercomShow has a message string
          if ($scope.intercomShow) {
            // Intercom shows new custom message view
            Intercom('showNewMessage', $scope.intercomShow);
          } else {
            // else show default landing view
            Intercom('show');
          }

          if ($scope.disableOnShow) {
            Intercom('onShow', function () {
              $elem.addClass('disabled');
            });
            Intercom('onHide', function () {
              $elem.removeClass('disabled');
            });
          }
        }
      });

      $scope.$on('$destroy', function () {
        $elem.off('click');
      });
    },
    scope: {
      intercomShow: '@',
      intercomEmail: '@?',
      disableOnShow: '<?',
    },
  };
}

IntercomShow.$inject = ['$log', '$window', 'ErrorReporter'];

angular.module('mode.components').directive('intercomShow', IntercomShow);
